import { createAsyncTypes } from 'utils/ActionCreator'

export const SERVER_SIDE_REQUEST_ASYNC = createAsyncTypes(
  'SERVER_SIDE_REQUEST',
  'Settings/EmailServer/ShowEmailServer'
)
export const MAILBOX_REQUEST_ASYNC = createAsyncTypes(
  'MAILBOX_REQUEST',
  'Settings/EmailServer/ShowMailbox'
)
export const UPDATE_MAILBOX_ASYNC = createAsyncTypes(
  'UPDATE_MAILBOX',
  'Settings/EmailServer/ShowMailbox'
)
export const DISABLE_MAILBOX_ASYNC = createAsyncTypes(
  'DISABLE_MAILBOX',
  'Settings/EmailServer/ShowMailbox'
)
export const UPDATE_SERVER_SIDE_ASYNC = createAsyncTypes(
  'UPDATE_SERVER_SIDE',
  'Settings/EmailServer/ShowEmailServer'
)
export const DELETE_SERVER_SIDE_ASYNC = createAsyncTypes(
  'DELETE_SERVER_SIDE',
  'Settings/EmailServer/ShowEmailServer'
)

export const exchangeAccessTypes = [
  { value: 0, label: 'Delegate' },
  { value: 1, label: 'Impersonation' },
]

export const exchangeAuthTypes = [
  { value: null, label: 'Try to Detect Automatically' },
  { value: 1, label: 'basic' },
  { value: 2, label: 'NTLM' },
  { value: 3, label: 'digest' },
]
